import { always, any, cond, endsWith, equals, includes, not, T } from "ramda";
import { isDevelopment, REACT_REMOTE_APP_ENVIRONMENT } from "src/constants";
import { getNamespaceName } from "../objects/namespaces";

/**
 * Determines the service prefix based on the environment and namespace.
 *
 * @param namespace - The namespace name to evaluate.
 * @returns The appropriate service prefix.
 */
const determineServicePrefix = (namespace: string): string => {

    return cond<string, string>([
        [() => equals(REACT_REMOTE_APP_ENVIRONMENT, 'development'), always('services-dev')],
        [() => any(suffix => endsWith(suffix, namespace), ['dev', 'uat']), always('services-uat')],
        [() => not(includes(REACT_REMOTE_APP_ENVIRONMENT, ['development', 'uat'])), always('services')],
        [T, always('')]
    ])(namespace);
};

/**
 * Constructs the full service endpoint URL.
 *
 * @returns The service endpoint URL.
 */
export const constructServiceEndpoint = (): string => {
    const namespace = getNamespaceName();
    const servicePrefix = determineServicePrefix(namespace);

    if (!servicePrefix) {
        throw new Error(`Unable to determine service endpoint`);
    }

    return isDevelopment
        ? `https://${window.location.hostname}:3000/service`
        : `https://${window.location.hostname}/service`;
};


